import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledPlatofrmsHero = styled.section`
	color: ${CSSVars.gray900};
	text-align: center;
	overflow: hidden;
	padding: 50px 20px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	.hero-wrapper {
		position: relative;

		h1 {
			position: relative;
			z-index: 10;
			margin: 0 auto;
			font-size: ${CSSVars.fontSize2XL};
			font-weight: 600;
			max-width: 600px;
			margin-bottom: 20px;
			text-align: left;

			@media screen and (min-width: ${CSSVars.breakpointSM}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				max-width: 750px;
				font-size: ${CSSVars.fontSize4XL};
			}
		}

		h2 {
			position: relative;
			z-index: 10;
			margin: 0 auto;
			font-size: ${CSSVars.fontSizeLG};
			max-width: 600px;
			font-weight: 300;
			text-align: left;

			@media screen and (min-width: ${CSSVars.breakpointSM}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				max-width: 670px;
				font-size: ${CSSVars.fontSizeXL};
			}
		}

		.icons {
			position: absolute;

			&.right {
				transform: scale(0.3);
				left: 50%;
				top: -120px;

				@media screen and (min-width: ${CSSVars.breakpointSM}) {
					left: 65%;
				}

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					transform: scale(0.5);
					left: 79%;
					top: -30px;
				}

				@media screen and (min-width: ${CSSVars.breakpointLG}) {
					transform: scale(0.7);
					left: 79%;
				}

				@media screen and (min-width: ${CSSVars.breakpointXL}) {
					transform: scale(1);
				}
			}

			&.left {
				display: none;

				@media screen and (min-width: ${CSSVars.breakpointSM}) {
					display: flex;
					transform: scale(0.3);
					right: 69%;
					top: -30px;
				}

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					transform: scale(0.5);
					right: 79%;
					top: -30px;
				}

				@media screen and (min-width: ${CSSVars.breakpointLG}) {
					transform: scale(0.75);
				}

				@media screen and (min-width: ${CSSVars.breakpointXL}) {
					transform: scale(1);
					right: 79%;
					top: -30px;
				}
			}
		}
	}
`;
